import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ClipboardService } from 'ngx-clipboard';
import { switchMap } from 'rxjs';

import { saveAs } from 'file-saver';
import { AnnexEnum, IAnnex, IInvoiceInfo, IRpaInfo } from 'src/app/models/annex';
import { DialogTypeEnum, IDialogConfirm, IDialogData, IDialogMessages } from 'src/app/models/dialog';
import { DetailLotEnum, IContractLot, ICustomSelect, IHeaderItem, ILot } from 'src/app/models/generic';
import { IBeneficiaryEconomicGroup, IManualBatchLiberacao } from 'src/app/models/manual-batch';
import { ServiceCodeLookup } from 'src/app/models/service-code';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ApiLotsService } from 'src/app/services/api/api-lots.service';
import { ApiManualBatchService } from 'src/app/services/api/api-manual-batch.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { TransferContractsHeaderItems } from 'src/app/shared/utils/base';
import { CampoNfComponent } from 'src/app/pages/detalhes-lotes/campo-nf/campo-nf.component';
import { CampoRpaComponent } from 'src/app/pages/detalhes-lotes/campo-rpa/campo-rpa.component';
import { PaymentBeneficiaryDialogComponent } from 'src/app/pages/detalhes-lotes-manual/header-list-manual/payment-beneficiary-dialog/payment-beneficiary-dialog.component';
import { LiberarManualDialogComponent } from 'src/app/shared/components/liberar-manual-dialog/liberar-manual-dialog.component';
import { DocumentValidator } from 'src/app/shared/validators/document.validator';
import { IContractByNumberFormData } from '../../../models/contract';

// Limite de caracteres de cada opção da lista de códigos de serviço (o texto completo vai no tooltip).
const SERVICE_CODE_LABEL_MAX_LENGTH = 70;

@Component({
  selector: 'app-sublote-card-v2',
  templateUrl: './sublote-card.component.html',
  styleUrls: ['./sublote-card.component.scss']
})
export class SubloteCardV2Component implements OnInit, OnChanges {
  private readonly defaultProductNamesById: Record<string, string> = {
    '00000000-0000-0000-0000-000000000001': 'Isolado',
    '00000000-0000-0000-0000-000000000002': 'Home Equity',
    '00000000-0000-0000-0000-000000000003': 'Portabilidade',
    '00000000-0000-0000-0000-000000000004': 'Consórcio',
    '00000000-0000-0000-0000-000000000005': 'Empréstimo Pessoal',
    '00000000-0000-0000-0000-000000000006': 'Repasse',
    '00000000-0000-0000-0000-000000000007': 'Construcasa',
    '00000000-0000-0000-0000-000000000008': 'Piloto'
  };

  @Input() partner!: ILot;
  @Input() index: number = 0;
  @Input() batchBlocked: boolean = false;
  @Input() parentBatchNumber: string = '';
  @Input() productsById: Record<string, string> = {};
  @Input() serviceCodes: ServiceCodeLookup[] = [];
  // Recalculando as retenções deste sublote (troca de código): os valores viram skeleton até o servidor responder.
  @Input() recalculating: boolean = false;
  @Input() integratedSubestabelecidoContractIds: Set<string> = new Set();
  @Input() selectedContractIdsToExclude: Set<string> = new Set();

  @Output() deleteContractEvent = new EventEmitter<{ contractId: string; isDelete: boolean }>();
  @Output() cancelSubBatchEvent = new EventEmitter<{ batchId: string; justificativa: string }>();
  @Output() serviceCodeChangeEvent = new EventEmitter<{ batchId: string; serviceCodeId: string | null }>();
  @Output() integrateSapEvent = new EventEmitter<string>();
  @Output() liberarManualEvent = new EventEmitter<{ payload: IManualBatchLiberacao }>();
  @Output() sendEmailEvent = new EventEmitter<{ paymentEmail: boolean; partnerId: string }>();
  @Output() previewEmailEvent = new EventEmitter<{ paymentEmail: boolean; partnerId: string }>();

  readonly AnnexEnum = AnnexEnum;
  batchType: 'transfer' | 'invoice' = 'transfer';
  paymentDate: FormControl<string> = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required]
  });
  // Só guarda o valor exibido; a troca sai pelo (change) do select e o servidor confirma via recarga do lote.
  serviceCodeControl: FormControl<string> = new FormControl('', { nonNullable: true });
  Math = Math;
  subBatchBlocked: boolean = false;
  blockCancel: boolean = false;
  dataCancelamentoProcessado: string | null = null;
  loadingCancelamentoStatus: boolean = false;
  private lastCancelamentoCheckBatchId: string | null = null;
  beneficiaryName: string = '';
  beneficiaryType: string = '';
  totalContractsTransferAmount: number = 0;
  showClipboardCopy: boolean = false;
  contracts: IContractLot[] = [];
  annexList: IAnnex[] = [
    {
      Title: AnnexEnum.AutorizacaoRepasse,
      File: '',
      isLoader: false,
      visible: true,
      AllowDownload: false,
      DisableUpload: false,
    },
    {
      Title: AnnexEnum.NotaFiscal,
      File: '',
      isLoader: false,
      visible: true,
      AllowDownload: false,
      DisableUpload: false,
    },
    {
      Title: AnnexEnum.Rpa,
      File: '',
      isLoader: false,
      visible: true,
      AllowDownload: false,
      DisableUpload: false,
    }
  ];

  constructor(
    private _batchService: ApiLotsService,
    private _dialog: MatDialog,
    private _snackbarService: SnackbarService,
    private _dialogService: ApiDialogService,
    private _manualBatchService: ApiManualBatchService,
    private _clipboardApi: ClipboardService,
    private _datePipe: DatePipe,
    private _currencyPipe: CurrencyPipe,
    private _titleCasePipe: TitleCasePipe,
    private loaderService: LoaderService,
  ) { }

  ngOnInit(): void {
    this.syncViewModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['partner']) {
      this.syncViewModel();
    }
  }

  private syncViewModel(): void {
    const contractsAmount = this.partner.Contracts?.reduce((total: number, c: IContractLot) => total + (c?.TransferAmount || 0), 0) || 0;
    const reversesAmount = this.partner.Reverses?.reduce((total: number, r: IContractLot) => total + (r?.TransferAmount || 0), 0) || 0;
    this.totalContractsTransferAmount = contractsAmount - reversesAmount;

    this.beneficiaryName = this.partner?.Partner
      || this.partner.Contracts?.[0]?.BeneficiaryName
      || this.partner.Reverses?.[0]?.BeneficiaryName
      || '-';

    this.beneficiaryType = this.partner.Contracts?.[0]?.BeneficiaryType
      || this.partner.Reverses?.[0]?.BeneficiaryType
      || 'Beneficiario';

    this.showClipboardCopy =
      (this.partner.Contracts != null && this.partner.Contracts.length > 0) ||
      (this.partner.Reverses != null && this.partner.Reverses.length > 0);

    this.subBatchBlocked =
      this.batchBlocked ||
      this.partner.PaymentDate != null ||
      this.partner.StatusOfOnlending?.toLocaleLowerCase() === 'cancelado' ||
      this.isManualReleaseStatus() ||
      (this.partner.Integrated == true && this.partner.IntegrationDate != null);

    // Cancelar integração OMIE (RN01/RN04): habilita quando ESTE sublote está integrado e
    // ainda não foi pago/agendado. Não depende de "batchBlocked" - esse flag reflete o master
    // já estar integrado/pago, que é justamente a condição que queremos permitir cancelar aqui
    // (usá-lo criaria um bloqueio circular). Se o par (master/substabelecido) já tiver sido pago
    // ou agendado, o backend rejeita a operação com uma mensagem clara (RN01) mesmo que o botão
    // apareça habilitado neste sublote.
    const isAgendado = this.partner.PaymentDate == null
      && this.partner.OmiePaymentStatus?.toLowerCase().trim() === 'agendado';
    const isPagoOuAgendado = this.partner.PaymentDate != null || isAgendado;

    this.blockCancel = isPagoOuAgendado || this.partner.Integrated != true;

    this.checkCancelamentoStatus();

    this.contracts = [...(this.partner.Contracts || []), ...(this.partner.Reverses || [])];
    this.paymentDate.setValue(this.paymentDateLocationEn ?? '', { emitEvent: false });
    this.serviceCodeControl.setValue(this.partner.ServiceCodeId ?? '', { emitEvent: false });

    // Optante pelo Simples Nacional/SIMEI não sofre retenção: sem código, seletor em "Nenhum" e desabilitado.
    // Regime nulo (parceiro sem cadastro no OMIE) vale como "não optante" e o seletor segue habilitado.
    if (this.isRetencaoIsenta) {
      this.serviceCodeControl.setValue('', { emitEvent: false });
      this.serviceCodeControl.disable({ emitEvent: false });
    } else {
      this.serviceCodeControl.enable({ emitEvent: false });
    }

    this.annexList[0].AllowDownload = !!this.partner.EconomicGroupAutorizationFile;
    this.annexList[0].DisableUpload = !!this.partner.DocuSignContractId;
    this.annexList[1].AllowDownload = !!this.partner.IsInvoiced;
    this.annexList[2].AllowDownload = !!this.partner.HasRpa;
    this.annexList[2].DisableUpload = !!this.partner.HasRpa;
  }

  get paymentDateLocationEn(): string | null {
    return new DatePipe('en-US').transform(this.partner.EstimatedPaymentDate ?? '', 'yyyy-MM-dd');
  }

  get isCpfPartner(): boolean {
    return !!this.partner.PartnerDocument && DocumentValidator.isCPF(this.partner.PartnerDocument);
  }

  get secondaryAnnexTitle(): AnnexEnum {
    return this.isCpfPartner ? AnnexEnum.Rpa : AnnexEnum.NotaFiscal;
  }

  get secondaryAnnexAllowDownload(): boolean {
    return this.isCpfPartner ? this.annexList[2].AllowDownload : this.annexList[1].AllowDownload;
  }

  get secondaryAnnexDisabled(): boolean {
    return this.isBatchReleased() || (this.isCpfPartner && this.annexList[2].DisableUpload);
  }

  get canEditInvoiceInfo(): boolean {
    return !this.isCpfPartner && !!this.partner.InvoiceNumber && !this.isBatchReleased();
  }

  get canEditPaymentDate(): boolean {
    return !!this.partner.Active && !this.isBatchReleased();
  }

  get canEditServiceCode(): boolean {
    // Espelha os bloqueios do backend (UpdateServiceCodeAsync): integrado, liberado, cancelado ou pago.
    return !!this.partner.Active
      && !this.isBatchReleased()
      && !this.partner.PaymentDate
      && this.getNormalizedBatchStatus() !== 'cancelado';
  }

  // serviceCodeOptions monta objetos novos a cada ciclo; sem trackBy o ngFor recria todos os <option>.
  trackByOptionId(_: number, option: ICustomSelect): string {
    return option.id;
  }

  // A lista do <select> nativo tem a largura da maior opção; as descrições da lista de serviços são longas,
  // então o texto é truncado e a frase completa fica no tooltip (title) da opção e do próprio campo.
  truncateOptionLabel(label: string): string {
    return label.length > SERVICE_CODE_LABEL_MAX_LENGTH
      ? `${label.slice(0, SERVICE_CODE_LABEL_MAX_LENGTH - 1).trimEnd()}…`
      : label;
  }

  get selectedServiceCodeName(): string | null {
    const selectedId = this.serviceCodeControl.value;

    return selectedId ? this.serviceCodeOptions.find(option => option.id === selectedId)?.name ?? null : null;
  }

  get serviceCodeOptions(): ICustomSelect[] {
    const options = this.serviceCodes.map(code => ({
      id: code.serviceCodeId,
      name: `${code.code} - ${code.description}`
    }));

    // O código do sublote pode ter sido inativado depois; sem esta opção o seletor apareceria vazio.
    const currentId = this.partner.ServiceCodeId;
    if (currentId && !options.some(option => option.id === currentId)) {
      options.unshift({
        id: currentId,
        name: `${this.partner.ServiceCodeValue ?? ''} - ${this.partner.ServiceCodeDescription ?? ''}`
      });
    }

    return options;
  }

  get serviceCodeLabel(): string {
    return this.partner.ServiceCodeValue
      ? `${this.partner.ServiceCodeValue} - ${this.partner.ServiceCodeDescription ?? ''}`
      : '—';
  }

  // RN02: Simples Nacional / SIMEI não sofrem retenção.
  get isRetencaoIsenta(): boolean {
    return this.partner.IsentoRetencao === true
      || this.partner.IsSimplesNacional === true
      || this.partner.IsSIMEI === true;
  }

  get retencaoIsencaoLabel(): string {
    const regime = this.partner.IsSimplesNacional === true ? 'Simples Nacional' : 'SIMEI';
    return `Isento — ${regime}`;
  }

  // Os seis tributos aparecem sempre, na ordem do protótipo (3 colunas), com R$ 0,00 quando não há retenção.
  // O percentual só é exibido quando há valor retido. Em PF o INSS mostra a alíquota do código (ou 11%) e o
  // IRPF, de tabela progressiva, fica sem percentual.
  get retencaoChips(): { label: string; rate: number | null | undefined; amount: number }[] {
    const p = this.partner;
    const isPf = this.isCpfPartner;

    return [
      { label: 'PIS', rate: p.PisRate, amount: p.PisAmount ?? 0 },
      { label: 'CSLL', rate: p.CsllRate, amount: p.CsllAmount ?? 0 },
      { label: 'ISS', rate: isPf ? this.pfIssRate : p.IssRate, amount: p.IssAmount ?? 0 },
      { label: 'COFINS', rate: p.CofinsRate, amount: p.CofinsAmount ?? 0 },
      { label: 'IR', rate: isPf ? null : p.IrRate, amount: p.IrAmount ?? 0 },
      { label: 'INSS', rate: isPf ? this.pfInssRate : p.InssRate, amount: p.InssAmount ?? 0 }
    ];
  }

  // Alíquota de ISS de PF: com código, a do código; sem código, os 2% legados (espelha RetencaoCalculator). Só é
  // retida com o toggle "Calcular ISS" ligado; desligado o valor é zero e o percentual não aparece.
  private get pfIssRate(): number {
    return this.partner.ServiceCodeId ? (this.partner.IssRate ?? 0) : 2;
  }

  // Alíquota nominal de INSS de PF: com código de serviço, a do código (0 = sem INSS); sem código, os 11%
  // previdenciários (espelha TransferBatchService.CalcularRetencao). O teto de contribuição vale nos dois casos.
  private get pfInssRate(): number {
    return this.partner.ServiceCodeId ? (this.partner.InssRate ?? 0) : 11;
  }

  hasRetencaoRate(chip: { rate: number | null | undefined; amount: number }): boolean {
    return !!chip.rate && chip.rate > 0 && chip.amount > 0;
  }

  get netValue(): number {
    return this.partner.NetAmount ?? this.totalContractsTransferAmount;
  }

  onServiceCodeChange(value: string): void {
    this.serviceCodeChangeEvent.emit({
      batchId: this.partner.BatchId.toString(),
      serviceCodeId: value || null
    });
  }

  get canIntegrateSapPartner(): boolean {
    // NF (IsInvoiced) para PJ ou RPA (HasRpa) para PF são equivalentes como comprovante de
    // faturamento - mesmo critério usado no footer do lote pai (batchIsInvoiced || batchHasRpa).
    return !!this.partner.Active
      && (!!this.partner.IsInvoiced || !!this.partner.HasRpa)
      && !this.partner.Integrated
      && !this.isManualReleaseStatus();
  }

  get canLiberarManual(): boolean {
    const normalizedStatus = this.getNormalizedBatchStatus();
    const hasManualOperationalData = !!this.partner.HasRpa || (!!this.partner.IsInvoiced && !!this.partner.InvoiceNumber);
    const isPendingStatus = normalizedStatus === 'emandamento' || !!this.partner.HasRpa;
    const isIntegrated = this.partner.Integrated === true && !!this.partner.IntegrationDate;
    const isCanceled = normalizedStatus === 'cancelado';

    return !this.batchBlocked
      && !!this.partner.Active
      && !isIntegrated
      && !isCanceled
      && !this.isManualReleaseStatus()
      && isPendingStatus
      && hasManualOperationalData;
  }

  get showIntegrationErrorButton(): boolean {
    return !!this.partner.IntegrationError && !!this.partner.IntegrationMsg;
  }

  get simplesNacionalLabel(): string {
    if (this.partner.IsSimplesNacional === true) {
      return 'Sim';
    }

    if (this.partner.IsSimplesNacional === false) {
      return 'Não';
    }

    return 'Não disponível';
  }

  get simeiLabel(): string {
    if (this.partner.IsSIMEI === true) {
      return 'Sim';
    }

    if (this.partner.IsSIMEI === false) {
      return 'Não';
    }

    return 'Não disponível';
  }

  get beneficiaryTypeLabel(): string {
    return this.beneficiaryType?.toLowerCase() === 'parceiro'
      ? 'Master'
      : this._titleCasePipe.transform(this.beneficiaryType || 'Beneficiario');
  }

  isContractBlockedByIntegratedSubestabelecido(contract: IContractLot): boolean {
    if (!contract.SubestabelecidoContractId) return false;
    return this.integratedSubestabelecidoContractIds.has(contract.SubestabelecidoContractId);
  }

  isContractSelectedForDelete(contractId: string): boolean {
    return this.selectedContractIdsToExclude.has(contractId);
  }

  getStatusClass(status: string | undefined): string {
    const s = (status || '').toLowerCase().trim();
    if (s === 'integrado' || s === 'integrado omie') return 'badge-integrado';
    if (s === 'cancelado') return 'badge-cancelado';
    if (s === 'aprovado') return 'badge-aprovado';
    if (s === 'liberado' || s === 'liberado manual') return 'badge-liberado';
    if (s === 'faturado') return 'badge-faturado';
    if (s === 'pendente' || s === 'em andamento') return 'badge-pendente';
    return 'badge-pendente';
  }

  getHeaderStatusLabel(): string {
    if (this.partner.StatusOfOnlending?.toLowerCase().trim() === 'cancelado') {
      return 'Cancelado';
    }

    if (this.partner.Integrated && this.partner.IntegrationDate) {
      return 'Integrado Omie';
    }

    if (this.partner.SapPaymentStatus?.toLowerCase().trim() === 'manual' && 
          this.partner.IntegrationDate) {
      return 'Liberado Manual';
    }

    return 'Pendente';
  }

  getHeaderStatusClass(): string {
    return this.getStatusClass(this.getHeaderStatusLabel());
  }

  getContractStatusClass(status: string | undefined): string {
    const normalizedStatus = (status || '').toLowerCase().trim();

    if (['integrado', 'aprovado', 'liberado', 'liberado manual', 'pago'].includes(normalizedStatus)) {
      return 'contract-badge-success';
    }

    if (normalizedStatus === 'registrado') {
      return 'contract-badge-brand';
    }

    if (['pendente', 'em andamento'].includes(normalizedStatus)) {
      return 'contract-badge-warn';
    }

    if (['cancelado', 'erro', 'rejeitado'].includes(normalizedStatus)) {
      return 'contract-badge-danger';
    }

    return 'contract-badge-neutral';
  }

  getContractProductLabel(contract: IContractLot): string {
    const contractData = contract as IContractLot & {
      productId?: string;
      productName?: string;
      product?: string;
      contractType?: string;
    };

    const productName = (contract.ProductName || contractData.productName || '').toString().trim();

    if (productName) {
      return productName;
    }

    const productId = (contract.ProductId || contractData.productId || '').toString().trim();
    const normalizedProductId = productId.toLowerCase();
    const productFromId =
      (productId ? this.productsById[productId] : '') ||
      (normalizedProductId ? this.productsById[normalizedProductId] : '') ||
      (normalizedProductId ? this.defaultProductNamesById[normalizedProductId] : '');

    const product = (
      productFromId ||
      contract.Product ||
      contractData.product ||
      contract.ContractType ||
      contractData.contractType ||
      productId ||
      ''
    ).toString().trim();

    return product || '-';
  }

  onSelectFile(eventFile: { event: Event; fileName: string }): void {
    const target = eventFile.event.target as HTMLInputElement;
    const { file } = this._batchService.validateFile(target);

    if (file) {
      const batchId = `${this.partner.BatchId}`;

      switch (eventFile.fileName) {
        case AnnexEnum.NotaFiscal:
          this.saveInvoiceFile(batchId, file);
          break;
        case AnnexEnum.AutorizacaoRepasse:
          this.saveAuthorizationFile(batchId, file);
          break;
        case AnnexEnum.Rpa:
          this.saveRpaFile(batchId, file);
          break;
      }
    }

    target.value = '';
  }

  handleAuthorizationAction(input: HTMLInputElement): void {
    if (this.annexList[0].AllowDownload) {
      this.getAuthorizationFile();
      return;
    }

    if (!this.annexList[0].DisableUpload) {
      input.click();
    }
  }

  handleSecondaryAnnexAction(input: HTMLInputElement): void {
    if (!this.secondaryAnnexDisabled) {
      input.click();
    }
  }

  downloadSecondaryAnnex(): void {
    if (this.isCpfPartner) {
      this.getRpaFile();
    } else {
      this.getInvoiceFile();
    }
  }

  saveInvoiceFile(batchId: string, file: File): void {
    const data: IInvoiceInfo = {
      BatchId: this.partner.BatchId.toString(),
      InvoiceDate: new DatePipe('pt-BR').transform(this.partner.InvoiceDate, 'yyyy-MM-dd') || '',
      InvoiceNumber: this.partner.InvoiceNumber || '',
    };

    const dialogRef = this._dialog.open(CampoNfComponent, { disableClose: true, data });
    dialogRef.afterClosed().subscribe((invoice: IInvoiceInfo | boolean) => {
      if (invoice) {
        this._batchService
          .postInvoiceFile(batchId, file)
          .pipe(switchMap(() => this._batchService.postInvoiceInfo(invoice as IInvoiceInfo)))
          .subscribe({
            next: () => {
              this.annexList[1].File = file;
              this.partner.IsInvoiced = true;
              this.partner.StatusOfOnlending = 'Aprovado';
              this.partner.InvoiceDate = (invoice as IInvoiceInfo).InvoiceDate;
              this.partner.InvoiceNumber = (invoice as IInvoiceInfo).InvoiceNumber;
              this._batchService.updateTemplateValuesEvent.next(invoice as IInvoiceInfo);
              this._snackbarService.openSnackBar('Arquivo enviado com sucesso!', 'success', 3000);
            }
          });
      }
    });
  }

  saveRpaFile(batchId: string, file: File): void {
    const data: IRpaInfo = {
      BatchId: this.partner.BatchId.toString(),
      RpaDate: '',
      RpaNumber: this.parentBatchNumber
    };

    const dialogRef = this._dialog.open(CampoRpaComponent, { disableClose: true, data });
    dialogRef.afterClosed().subscribe((rpa: IRpaInfo | boolean) => {
      if (rpa) {
        this._batchService
          .postRpaFile(batchId, file)
          .pipe(switchMap(() => this._batchService.postRpaInfo(rpa as IRpaInfo)))
          .subscribe({
            next: () => {
              this.annexList[2].File = file;
              this.partner.HasRpa = true;
              this.partner.StatusOfOnlending = 'Aprovado';
              this.partner.RpaDate = (rpa as IRpaInfo).RpaDate;
              this.partner.RpaNumber = (rpa as IRpaInfo).RpaNumber;
              this._batchService.updateTemplateValuesEventRpa.next(rpa as IRpaInfo);
              this._snackbarService.openSnackBar('Arquivo enviado com sucesso!', 'success', 3000);
            }
          });
      }
    });
  }

  saveAuthorizationFile(batchId: string, file: File): void {
    this._manualBatchService.postAuthorizationFile(batchId, file).subscribe({
      next: () => {
        this.annexList[0].File = file;
        this.partner.EconomicGroupAutorizationFile = 'application/pdf';
        this._snackbarService.openSnackBar('Arquivo enviado com sucesso!', 'success', 3000);
      }
    });
  }

  getAuthorizationFile(): void {
    this._manualBatchService.getAuthorizationFile(this.partner.BatchId.toString()).subscribe({
      next: (response: Blob) => {
        saveAs(response, 'AutorizacaoDeRepasse.pdf');
      },
      error: () => {
        this._snackbarService.openSnackBar('Erro ao buscar Autorização de Repasse!', SnackbarType.Danger);
      }
    });
  }

  getInvoiceFile(): void {
    this._batchService.getInvoiceFile(this.partner.BatchId.toString(), this.batchType).subscribe({
      next: (response: Blob) => {
        saveAs(response, 'NotaFiscal.pdf');
      },
      error: () => {
        this._snackbarService.openSnackBar('Erro ao buscar NF do lote!', SnackbarType.Danger);
      }
    });
  }

  getRpaFile(): void {
    this._batchService.getRpaFile(this.partner.BatchId.toString(), this.batchType).subscribe({
      next: (response: Blob) => {
        saveAs(response, 'Rpa.pdf');
      },
      error: () => {
        this._snackbarService.openSnackBar('Erro ao buscar RPA do lote!', SnackbarType.Danger);
      }
    });
  }

  private checkCancelamentoStatus(): void {
    const batchId = this.partner.BatchId?.toString() ?? null;

    if (!this.partner.CancelamentoSapCode || batchId === this.lastCancelamentoCheckBatchId) {
      return;
    }

    this.lastCancelamentoCheckBatchId = batchId;
    this.dataCancelamentoProcessado = null;
    this.loadingCancelamentoStatus = true;

    this._manualBatchService.getCancelamentoStatus(this.partner.BatchId.toString()).subscribe({
      next: (res) => {
        this.dataCancelamentoProcessado = res.Data;
        this.loadingCancelamentoStatus = false;
      },
      error: () => {
        this.loadingCancelamentoStatus = false;
      }
    });
  }

  handleCancelSubBatch(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.OptionalWithField,
      appearance: 'modern',
      template: {
        boldTitle: 'Cancelar integração com o OMIE',
        title: 'Tem certeza que deseja cancelar a integração deste sublote com o OMIE? Se sim, informe a justificativa.',
        confirm: 'Sim',
        dismiss: 'Não',
        description: 'Justificativa'
      }
    };
    this._dialogService.openDialog(dialogData).then((response: boolean | string) => {
      if (response) {
        this.cancelSubBatchEvent.emit({
          batchId: this.partner.BatchId.toString(),
          justificativa: String(response)
        });
      }
    });
  }

  handleIntegrateSapPartner(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Integrar OMIE',
        title: 'Tem certeza que deseja integrar OMIE?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };
    this._dialogService.openDialog(dialogData).then((response: boolean | string) => {
      if (response) {
        this.integrateSapEvent.emit(this.partner.BatchId.toString());
      }
    });
  }

  handleLiberarManual(): void {
    const dialogRef = this._dialog.open(LiberarManualDialogComponent, {
      data: { batchId: this.partner.BatchId.toString() },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: { payload: IManualBatchLiberacao } | undefined) => {
      if (result) {
        this.liberarManualEvent.emit({ payload: result.payload });
      }
    });
  }

  getPaymentProof(): void {
    const loadingId = this.loaderService.show();
    this._batchService.getPaymentProof(this.partner.BatchId.toString()).subscribe({
      next: (response: Blob) => {
        this.loaderService.hide(loadingId);
        const blob = new Blob([response], { type: 'application/pdf' });
        saveAs(blob, `ComprovantePagamento-${this.parentBatchNumber}.pdf`);
      },
      error: () => {
        this.loaderService.hide(loadingId);
        this._snackbarService.openSnackBar('Erro ao buscar o comprovante de pagamento!', SnackbarType.Danger);
      }
    });
  }

  handleInvoiceInfo(): void {
    const data: IInvoiceInfo = {
      BatchId: this.partner.BatchId.toString(),
      InvoiceDate: new DatePipe('pt-BR').transform(this.partner.InvoiceDate, 'yyyy-MM-dd') || '',
      InvoiceNumber: this.partner.InvoiceNumber ?? ''
    };
    const dialogRef = this._dialog.open(CampoNfComponent, {
      disableClose: true,
      data
    });
    dialogRef.afterClosed().subscribe((result: IInvoiceInfo | boolean) => {
      if (result) {
        this.updateInvoiceInfo(result as IInvoiceInfo);
      }
    });
  }

  updateInvoiceInfo(invoice: IInvoiceInfo): void {
    this._batchService.postInvoiceInfo(invoice).subscribe({
      next: () => {
        this._snackbarService.openSnackBar('Informações alteradas com sucesso!', 'success');
        this.partner.InvoiceDate = invoice.InvoiceDate;
        this.partner.InvoiceNumber = invoice.InvoiceNumber;
      }
    });
  }

  handleBeneficiary(): void {
    const dialogRef = this._dialog.open(PaymentBeneficiaryDialogComponent, {
      disableClose: true,
      data: this.partner
    });

    dialogRef.afterClosed().subscribe({
      next: (response: IBeneficiaryEconomicGroup) => {
        if (response) {
          this.partner.OfficeName = response.BeneficiaryName;
          this.partner.OfficeDocument = response.Document;
        }
      }
    });
  }

  handlePaymentDate(): void {
    this._manualBatchService
      .saveEstimatedPaymentDate(this.partner.BatchId.toString(), { EstimatedPaymentDate: this.paymentDate.value })
      .subscribe({
        next: () => {
          this.partner.EstimatedPaymentDate = this.paymentDate.value;
          this._snackbarService.openSnackBar('Data cadastrada com sucesso!', 'success', 3000);
        }
      });
  }

  showIntegrationErrorMessage(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Confirmation,
      appearance: 'modern',
      template: {
        boldTitle: 'Erro de integração',
        title: this.partner.IntegrationMsg ?? 'Erro de integração',
        confirm: 'Voltar'
      }
    };

    this._dialogService.openDialog(dialogData).then(() => undefined);
  }

  exportToClipboard(): void {
    const contracts = [...(this.partner.Contracts || []), ...(this.partner.Reverses || [])];
    const text = (value: unknown) => value ?? '';
    let content = '\tN° Contrato\tBanco\tValor Financiamento\tValor Repasse\tOperação\tCliente\tCPF/CNPJ Cliente\tCanal\tDt. Produção\tLote\tStatus\r\n';
    contracts.forEach((contract: IContractLot) => {
      const status = contract.Active ? 'Ativo' : 'Cancelado';
      // Mesmo valor exibido na grid: estornos usam TransferAmountNegativo, contratos usam TransferAmount.
      const transferAmount = contract.TransferAmountNegativo || contract.TransferAmount || 0;
      content += [
        status,
        text(contract.Number),
        text(this._titleCasePipe.transform(contract?.FinancialInstitution)),
        text(this._currencyPipe.transform(contract.Amount, 'BRL')),
        text(this._currencyPipe.transform(transferAmount, 'BRL')),
        text(contract.OperationType),
        text(contract.Client),
        text(contract.ClientDocument),
        text(contract.Chanel),
        text(this._datePipe.transform(contract.ProductionDate, 'dd/MM/yyyy')),
        text(contract.InvoiceBatchNumber),
        text(contract.Status)
      ].join('\t') + '\r\n';
    });
    this._clipboardApi.copy(content);
    this._snackbarService.openSnackBar('Dados copiados para a área de transferência!', 'success', 3000);
  }

  openModalDetails(number: string) {
    const data: IContractByNumberFormData = {
      Number: number,
      Contract: this.contracts.find(c => c.Number === number)
    };

    this._dialogService.openContractDetailsDialog(data).then((response) => {});
  }

  private getNormalizedBatchStatus(): string {
    return (this.partner.StatusOfOnlending || this.partner.BatchStatus || '')
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  private isManualReleaseStatus(): boolean {
    const normalizedStatus = this.getNormalizedBatchStatus();
    const sapPaymentStatus = (this.partner.SapPaymentStatus || '').toLowerCase().trim();

    return normalizedStatus === 'liberadomanual' || sapPaymentStatus === 'manual';
  }

  private isBatchReleased(): boolean {
    const normalizedStatus = this.getNormalizedBatchStatus();
    const isReleasedStatus = normalizedStatus === 'liberado' || normalizedStatus === 'liberadomanual';

    return !!this.partner.Integrated || isReleasedStatus || this.isManualReleaseStatus();
  }
}
